<template>
  <DeepZoomSample></DeepZoomSample>
</template>

<script>
import 'photoswipe/style.css';
import DeepZoomSample from "@/views/DeepZoomSample";
export default {
  name: "QuickView",
  components: {
    DeepZoomSample
  },
  data() {
    return {

    };
  },
  mounted() {
    console.log("quick view=============")
  },
  methods:{

  }
}
</script>

<style scoped>

</style>
